import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LessonState {
  currentLesson: ILesson;
  allLessons: ILesson[];
  originalLessons: ILesson[];
  rightPanel: "main" | "alternate";
  currentSelectedContentId: number | null;
  alterantesOptions: IConfig[];
  alternateRequirements: string;
}

export const initalLesson = {
  _id: "",
  title: "",
  type: "",
  content: [],
  module: "",
  requirements: ["", ""],
  customLesson: "",
};

const initialState: LessonState = {
  currentLesson: initalLesson,
  allLessons: [],
  originalLessons: [],
  rightPanel: "main",
  currentSelectedContentId: null,
  alterantesOptions: [],
  alternateRequirements: "",
};

const lessonSlice = createSlice({
  name: "lesson",
  initialState,
  reducers: {
    setCurrentLesson: (state, action: PayloadAction<ILesson>) => {
      state.currentLesson = action.payload;
    },
    updateLessonState: (state, action: PayloadAction<Partial<LessonState>>) => {
      Object.assign(state, action.payload);
    },
    cleanLesson: () => initialState,
  },
});

export const { setCurrentLesson, updateLessonState, cleanLesson } =
  lessonSlice.actions;

export default lessonSlice.reducer;
